module.exports = __webpack_public_path__ + "static/vc_ui-6725a8d91069abb9c61a3ffc9e50e65d.png";